var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend"
  }, [_c('div', {
    staticClass: "legend-header"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/master-data/people.svg")
    }
  }), _c('span', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.filter.form.responsibles')) + " ")])]), _c('div', {
    staticClass: "legend-responsibles",
    class: _vm.responsibleCountClass
  }, _vm._l(_vm.responsibles, function (responsible) {
    return _c('div', {
      key: responsible.id,
      staticClass: "legend-responsible"
    }, [_c('div', {
      staticClass: "little-circle",
      style: {
        'background-color': responsible.color
      }
    }), _c('span', {
      staticClass: "responsible-name"
    }, [_vm._v(_vm._s(responsible.name))])]);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }